import { FaqsComponent } from "./../../components/faqs/faqs.component";
import { RouterModule } from "@angular/router";
import { PhoenixModalModule } from "@kehe/phoenix-modal";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PhoenixSearchModule } from "@kehe/phoenix-search";
import { PhoenixButtonModule } from "@kehe/phoenix-button";
import { PhoenixFaqsAccordionListComponent } from "@kehe/phoenix-faqs";

@NgModule({
  declarations: [FaqsComponent],
  imports: [
    CommonModule,
    PhoenixModalModule,
    RouterModule,
    PhoenixSearchModule,
    PhoenixButtonModule,
    PhoenixFaqsAccordionListComponent,
  ],
  exports: [FaqsComponent],
})
export class HelpModule {}
